<script setup>
defineProps({
  modelValue: {
    type: String,
    default: '',
  },
  placeholder: {
    type: String,
    default: '',
  },
  clearLabel: {
    type: String,
    required: true,
  },
  type: {
    type: String,
    default: 'text',
  },
});

const emit = defineEmits([
  'update:modelValue',
  'input',
  'focus',
  'enter',
  'clear',
]);

const updateValue = event => {
  emit('update:modelValue', event.target.value);
  emit('input', event);
};

const clear = () => {
  emit('update:modelValue', '');
  emit('clear');
};
</script>

<template>
  <label
    class="relative flex items-center gap-2 rounded-[50px] border-0 bg-[rgba(194,189,184,0.15)] px-3.5 py-[3px] shadow-[inset_0_0_0_0_transparent] transition-shadow duration-150 hover:shadow-[inset_0_0_0_1px_#c4c4c4] focus-within:shadow-[inset_0_0_0_1.5px_#1b8755] dark:bg-white/[0.04] dark:hover:shadow-[inset_0_0_0_1px_#3f3f46] max-md:gap-[7px] max-md:px-3 max-md:py-0"
  >
    <svg
      class="size-4 shrink-0 text-[#8a8a8a] dark:text-zinc-400 max-md:size-[15px]"
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      stroke-width="2"
      stroke-linecap="round"
      stroke-linejoin="round"
      aria-hidden="true"
    >
      <circle cx="11" cy="11" r="7" />
      <path d="m21 21-4.3-4.3" />
    </svg>
    <input
      :value="modelValue"
      :type="type"
      autocomplete="off"
      :placeholder="placeholder"
      class="m-0 h-10 min-w-0 flex-1 border-0 !bg-transparent p-0 text-[13px] leading-10 text-gray-800 !shadow-none !outline-none placeholder:text-[#8a8a8a] focus:border-0 focus:!bg-transparent focus:!shadow-none focus:!outline-none dark:text-neutral-200 dark:placeholder:text-zinc-400 max-md:!h-11 max-md:text-xs max-md:!leading-[44px] [&::-webkit-search-cancel-button]:hidden"
      @input="updateValue"
      @focus="emit('focus', $event)"
      @keydown.enter="emit('enter', $event)"
    />
    <button
      v-if="modelValue"
      type="button"
      class="inline-flex size-5 shrink-0 cursor-pointer items-center justify-center rounded-full border-0 bg-transparent p-0 text-[#8a8a8a] transition-colors hover:bg-black/[0.06] hover:text-gray-600 dark:text-zinc-400 dark:hover:bg-white/[0.08] dark:hover:text-neutral-200 max-md:!size-11"
      :aria-label="clearLabel"
      @click="clear"
    >
      <span class="i-lucide-x size-3.5" aria-hidden="true" />
    </button>
  </label>
</template>
